import { render, staticRenderFns } from "./InputArticle.vue?vue&type=template&id=2ef477d7&"
import script from "./InputArticle.vue?vue&type=script&lang=js&"
export * from "./InputArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports